const { REACT_APP_CONTEXT_PATH } = process.env;

export const ratingApi = () => {
  return {
    apiUrl: REACT_APP_CONTEXT_PATH + `/ticket/rating`,
  };
};
